<ng-container *ngIf="competition_documents_service.store.hasDocuments()">
  <app-see-more [maxHeightPx]="170">

<h2>{{'Documents' | transloco}}</h2>
<div class="links__block">
  <ng-container *ngFor="let comp_document of competition_documents_service.data.documents">
    <a [href]="comp_document.url" target="_blank">{{comp_document.label}}</a>
  </ng-container>
</div>
</app-see-more>
</ng-container>
